<template>
  <div class="principal-caja-dorada">
    <!-- Modal Archivo-->
    <div
      class="modal fade"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      id="modalArchivo"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content modal-archivo">
          <div class="modal-header modal-archivo__encabezado">
            <h5 class="modal-title">{{ this.tituloDocumento }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <iframe
              id="iframeDocumento"
              class="pdf-archivo"
              :src="this.ligaArchivo"
              type="content"
            ></iframe>
          </div>
          <div class="container text-start">
            <div
              v-if="subiendoArchivo"
              style="display: flex; justify-content: center"
            >
              <v-progress-circular
                :size="30"
                :width="4"
                color="#b8725a"
                indeterminate
              ></v-progress-circular>
            </div>
            <div v-if="!subiendoArchivo">
              <div>
                <label style="padding-left: 10px">
                  Elige el archivo que desas actualizar para sustituir el que se
                  muestra en pantalla.
                </label>
                <input
                  class="d-none"
                  type="file"
                  ref="inputDocumentoLleno"
                  @change="almacenarArchivoLleno"
                />
                <div class="col-lg-6">
                  <InputDocumentos
                    @click.native="activaInput()"
                    ajusteMarginBoton="margin-top: 0px !important"
                    :Documento="this.tipoDocumentoArchivo"
                    :NombreArchivo="this.NombreActual"
                    :esExtranjero="false"
                  ></InputDocumentos>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary modal-archivo__boton"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Fin Modal Archivo-->
    <titulo-seccion
      :titulo="$route.name == 'EditarPerfil' ? 'EDITAR MASTER' : 'CREAR MASTER'"
    ></titulo-seccion>

    <div class="container">
      <p class="titulo-instrucciones mt-5">Datos Generales</p>
      <p class="parrafo-instrucciones parrafo-agenda mt-2">
        Ingresa correctamente tus datos en cada uno de los campos.
      </p>
      <div class="row">
        <div v-if="tipo == 'M'" class="col-lg-6">
          <etiqueta-campo texto="Perfil" :requerido="true"></etiqueta-campo>
          <v-select
          :items="roles"
          label="Selecciona un perfil"
          dense
          solo
          v-model="rol"
          item-text="nombre"
          item-value="rolId"
          color="#b8725a"
          append-icon="mdi-chevron-down"
          :disabled="$route.name == 'EditarPerfil' ? true : false"
        ></v-select>
        </div>
        <div class="col-lg-6">
          <etiqueta-campo texto="Nombre(s)" :requerido="true"></etiqueta-campo>
          <input
            placeholder="Nombre(s) *"
            maxlength="100"
            type="text"
            class="form-control campo-basico"
            v-model="nombre"
            required
            pattern="^[a-zA-Z ]"
            oninvalid="setCustomValidity('Please enter on alphabets only. ')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <etiqueta-campo
            texto="Apellido paterno"
            :requerido="true"
          ></etiqueta-campo>
          <input
            placeholder="Apellido Paterno *"
            maxlength="100"
            type="text"
            class="form-control campo-basico"
            v-model="apellidoPaterno"
            required
          />
        </div>
        <div class="col-lg-6">
          <etiqueta-campo texto="Apellido materno"></etiqueta-campo>
          <input
            placeholder="Apellido Materno *"
            maxlength="100"
            type="text"
            class="form-control campo-basico"
            v-model="apellidoMaterno"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <etiqueta-campo texto="Teléfono" :requerido="true"></etiqueta-campo>
          <input
            placeholder="Teléfono móvil (10 dígitos) *"
            type="number"
            onkeydown="return event.keyCode !== 69"
            onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
            min="0"
            maxlength="10"
            class="form-control campo-basico"
            v-model="telefono"
            required
          />
        </div>
        <div class="col-lg-6">
          <etiqueta-campo
            texto="Correo electrónico"
            :requerido="true"
          ></etiqueta-campo>
          <input
            placeholder="Correo electrónico (ej. nombre@mail.com) *"
            type="email"
            class="form-control campo-basico"
            v-model="correo"
            required
          />
        </div>
      </div>
      <div v-if="tipo == 'M'" class="row">
        <div class="col-lg-6">
          <etiqueta-campo texto="Sucursal" :requerido="true"></etiqueta-campo>
          <v-select
          :items="proyectos"
          label="Selecciona una sucursal *"
          dense
          solo
          v-model="proyecto"
          item-text="nombre"
          item-value="proyectoVentaId"
          color="#b8725a"
          append-icon="mdi-chevron-down"
        ></v-select>
        </div>
        <div class="col-lg-6">
          <etiqueta-campo texto="Gerencia"></etiqueta-campo>
          <v-select
          :items="gerencias"
          label="Selecciona una generencia"
          dense
          solo
          v-model="gerencia"
          item-text="nombre"
          item-value="gerenciaId"
          color="#b8725a"
          append-icon="mdi-chevron-down"
        ></v-select>
        </div>
      </div>
      <div v-if="tipo == 'M'" class="row align-items-end">
        <div class="col-lg-6">
          <etiqueta-campo texto="Jefe directo"></etiqueta-campo>
          <v-select
          :items="jefes"
          label="Selecciona un jefe directo"
          dense
          solo
          v-model="jefe"
          item-text="nombre"
          item-value="jefeId"
          color="#b8725a"
          append-icon="mdi-chevron-down"
        ></v-select>
        </div>
        <div
          class="col-lg-2 text-start"
          v-if="jefe && !existeJefeSeleccionado()"
        >
          <button
            class="boton-primario w-100 px-2 py-2"
            @click="agregarJefe(jefe)"
          >
            <i class="fas fa-solid fa-user-plus me-2"></i>
            Agregar
          </button>
        </div>
      </div>
      <div class="row text-start" v-if="jefesSeleccionados">
        <div class="col-md-6">
          <div
            class="my-5"
            v-for="({ nombre, jefeId }, index) in jefesSeleccionados"
            :key="index"
          >
            <v-chip
              style="border-radius: 0px !important"
              close
              color="#b8725a"
              label
              outlined
              @click:close="eliminarJefeSeleccionado(jefeId)"
            >
              <p class=" mb-0 ocultar-texto">{{ nombre }}</p>
            </v-chip>
          </div>
        </div>
      </div>
      <div class="row justify-content-end my-5">
        <div class="col-lg-4" v-if="$route.name == 'EditarPerfil'">
          <button
            disabled
            v-if="loadingGuardar"
            class="boton-primario px-5 py-2 me-4 w-100"
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="white"
            ></v-progress-circular>
          </button>
          <button
            v-else
            class="boton-primario px-5 py-2 me-4 w-100"
            @click="editarPerfil()"
          >
            Editar perfil
          </button>
        </div>
        <div class="col-lg-4" v-else>
          <button
            disabled
            v-if="loadingGuardar"
            class="boton-primario px-5 py-2 me-4 w-100"
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="white"
            ></v-progress-circular>
          </button>
          <button
            v-else
            class="boton-primario px-5 py-2 me-4 w-100"
            @click="guardarPerfil()"
          >
            Agregar perfil
          </button>
        </div>
      </div>
    </div>
    <!--Inicio Archivos-->
    <div v-if="tipo == 'P'" class="container mb-5">
      <p class="titulo-instrucciones">Contratos y Kit</p>
      <p class="parrafo-instrucciones parrafo-agenda mt-2">
        Actualiza los archivos que sean necesarios dentro de cada opción.
      </p>
      <div class="caja-manuales">
        <div
          class="caja-manuales__manual"
          v-for="contrato in Contratos"
          v-bind:key="contrato.archivoId"
        >
          <button
            @click.prevent="
              VerContrato(
                contrato.archivoId,
                contrato.tipoDocumento,
                contrato.nombreOriginal
              )
            "
            class="caja-manules__boton"
            data-bs-toggle="modal"
            data-bs-target="#modalArchivo"
          >
            {{ ObtenerTituloArchivo(contrato.tipoDocumento) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
// Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

const rutaCargarArchivosGenericos =
  "/api/Master/CajaDorada/CargarDocumentosGenericosCajaDorada";
const rutaCargarContratosCliente = "/api/Master/CajaDorada/CargarContratos";
const rutaDescargarArchivo = "/api/Master/CajaDorada/VerArchivo";
const rutaDescargarArchivoTodos = "/api/Master/Archivo/DescargarArchivo";
const rutaDescargarArchivoZip = "/api/Master/Archivo/DescargarArchivosZip";
const rutaGuardarArchivoLleno =
  "/api/Master/CajaDorada/GuardarArchivoLlenoAdmin";
// const rutaGuardarArchivoLleno = "/api/Master/CajaDorada/GuardarArchivoLleno";
const rutaDescargarContrato = "/api/Master/CajaDorada/DescargarContrato";
const RutaActualizarContratosFirma =
  "/api/Master/CajaDorada/ActualizarContratosFirma";
const rutaObtenerFigurasAdicionales =
  "/api/Master/FiguraAdicional/ObtenerFiguraAdicionalProspectoPadre";
const rutaConsultarProspectoRepresentante =
  "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";
const rutaConsultarPosiblesJefes = "/api/Master/Master/ObtenerPosiblesJefes";
// const rutaConsultaSolicitudPreventa =
//   "/api/Master/Prospecto/ObtenerSolicitudPreventa";

export default {
  name: "AltaPerfil",
  components: {
    TituloSeccion,
    InputDocumentos,
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
      roles: [],
      rol: null,
      nombreRol: null,
      nombre: null,
      apellidoPaterno: null,
      apellidoMaterno: null,
      telefono: null,
      correo: null,
      proyectos: [],
      proyecto: null,
      proyectoVentaId: null,
      gerencias: [],
      gerencia: null,
      jefes: [],
      jefe: null,
      jefesSeleccionados: [],
      activo: true,
      loadingGuardar: false,
      sucursalId: null,
      gerenciaId: null,
      token: null,
      ArchivoActual: 0,
      ArchivoGenerico: [],
      ArchivosGenericos: [],
      ArchivosGenericosSoloLectura: [],
      ArchivosFirmados: [],
      Contratos: [],
      ContratosFirmados: false,
      ligaArchivo: null,
      tituloDocumento: "Documento Hir Casa",
      documentoLlenar: null,
      tipoDocumentoArchivo: null,
      archivoLleno: null,
      archivoIdActual: null,
      NombreActual:
        this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? "Selecciona un archivo.."
          : "Select a file...",
      subiendoArchivo: false,
      Existe: false,
      soloLectura: false,
      FirmandoContratos: false,
      FigurasAdicionales: [],
      Cotitulares: [],
      FirmadosCompleto: false,
      VerificarArchivosGenericos: 0,
      VerificarArchivosGenericosSoloLectura: 0,
      ProspectoRepresentanteLegalId: null,
      avisoCarga: true,
      preventa: false,
      tipoPersona: 0,
      ProspectoId: 0,
      tipo: "",
    };
  },
  watch: {
    // nombre() {
    //   var regExpTexto = /^[a-zA-Z ]*$/;

    //   if (this.nombre != "") {

    //     var valido = regExpTexto.test(this.nombre);
    //     if (valido == false) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // },
    apellidoPaterno(value) {
      let valorAnterior = value.length - 1;
      let valor = value;
      var regExpTexto = /^[a-zA-Z ]*$/;
      if (this.apellidoPaterno != "") {
        var valido = regExpTexto.test(valor);
        if (valido == false) {
          valor = valorAnterior;
        } else {
          this.apellidoPaterno = valor;
        }
      }
    },
    apellidoMaterno(value) {
      let valorAnterior = value.length - 1;
      let valor = value;
      var regExpTexto = /^[a-zA-Z ]*$/;
      if (this.apellidoMaterno != "") {
        var valido = regExpTexto.test(valor);
        if (valido == false) {
          valor = valorAnterior;
        } else {
          this.apellidoMaterno = valor;
        }
      }
    },
    // correo(value) {
    //   var regExpTexto = /^[a-zA-Z ]*$/;
    //   var valido = regExpTexto.test(value);

    //   if (valido == false) return false;
    //   return true;
    // },
    telefono(value) {
      if (this.telefono.length > 10) {
        this.telefono = value.substring(0, 10);
      }
    },
    proyecto: {
      handler: function(value) {
        this.proyectoVentaId = value;
        this.gerencias = [];
        this.gerenciasProyecto(this.proyectoVentaId);
      },
    },
    gerencia(value) {
      this.gerenciaId = value;
    },
    async rol(value) {
      if (this.$route.name != "EditarPerfil") {
        this.rol = value;
        await this.nombrarRol(this.rol);
        await this.obtenerPosiblesJefes();
      }
    },
  },
  async mounted() {
    this.token = window.sessionStorage.getItem("Token");
    this.rolesMaster();
    this.proyectoMaster(false);
    this.gerenciasProyecto(this.proyectoVentaId);
    this.tipo = this.$route.params.tipo;

 

    if (this.tipo == "M") {
      await this.obtenerInfoMasterId();
    } else {
      await this.obtenerInfoUsuarioId();
    }

    if (this.tipoPersona == 1) {
      await this.ConsultarProspectoRepresentanteLegal();
    }
    if (this.tipoPersona == 1) {
      await this.ConsultarSolicitudes(this.ProspectoId, true);
      this.solicitudExistenteId = this.SolicitudRepresentanteId;
    } else {
      await this.ConsultarSolicitudes(this.ProspectoId, false);
      this.solicitudExistenteId = this.SolicitudId;
    }
    if (this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral(
        this.ProspectoRepresentanteLegalId != 0
          ? this.ProspectoRepresentanteLegalId
          : this.ProspectoId
      );
    }

    await this.ObtenerFigurasAdicionales();
    await this.ObtenerArchivosGenericos();
    await this.ObtenerContratosCliente();
  },
  methods: {
    nombrarRol(rolId) {
      if (rolId === 1) {
        this.nombreRol = "EMBAJADOR";
      } else if (rolId === 2) {
        this.nombreRol = "PREAUTORIZADOR";
      } else if (rolId === 3) {
        this.nombreRol = "ADMINISTRADOR";
      } else if (rolId === 4) {
        this.nombreRol = "GERENTE";
      } else if (rolId === 6) {
        this.nombreRol = "MASTER OPERATIVO";
      } else if (rolId === 7) {
        this.nombreRol = "MASTER COMERCIAL";
      } else if (rolId === 8) {
        this.nombreRol = "GERENTE REGIONAL";
      } else if (rolId === 9) {
        this.nombreRol = "ADMINISTRADOR COMERCIAL";
      } else if (rolId === 10) {
        this.nombreRol = "SUPER ADMINISTRADOR";
      }
    },
    async ConsultarProspectoRepresentanteLegal() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaConsultarProspectoRepresentante, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ProspectoRepresentanteLegalId = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerFigurasAdicionales() {
      this.FigurasAdicionales = [];
      const prospectoPadreId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaObtenerFigurasAdicionales, prospectoPadreId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.FigurasAdicionales = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoLleno(event) {
      this.archivoLleno = event.target.files[0];
      this.subirArchivoLleno();
    },
    activaInput() {
      this.$refs["inputDocumentoLleno"].click();
    },
    async subirArchivoLleno() {
      if (this.ProspectoId != null) {
        if (this.archivoLleno === null) {
          this.$fire({
            title: "Carga de archivo",
            html: "<br>Debe cargar un archivo<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (!servicios.validarFormatoArchivoValido(this.archivoLleno)) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (!servicios.validarTamanioArchivoValido(this.archivoLleno)) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }
        this.subiendoArchivo = true;
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.archivoLleno);
        paqueteDeDatos.append("archivoId", this.ArchivoActual);
        await axios
          .post(rutaGuardarArchivoLleno, paqueteDeDatos)
          .then(async (resp) => {
            if (resp.data.estado === 0) {
              this.subiendoArchivo = false;

              await this.ObtenerArchivosGenericos();
              await this.ObtenerContratosCliente();
            } else if (resp.data.estado === 1) {
              this.subiendoArchivo = false;
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.subiendoArchivo = false;
            this.ManejarExcepcion(e);
          });
      }
    },
    async ActualizarContratosFirma() {
      let objetoPrueba = {
        prospectoId: this.ProspectoId,
        archivo: this.ArchivosFirmados,
      };
      await axios
        .post(RutaActualizarContratosFirma, objetoPrueba)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            this.ContratosFirmados = true;
            await this.ObtenerContratosCliente();
            await this.EnviaCorreoContratosFirmados();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ActualizarGenericosFirma() {
      let objetoPrueba = {
        prospectoId: this.ProspectoId,
        archivo: this.ArchivoGenerico,
      };
      await axios
        .post(RutaActualizarContratosFirma, objetoPrueba)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            await this.ObtenerArchivosGenericos();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    descargarTodosLosArchivosZip() {
      //No dejar espacios en el nombre
      var nombreZip = "DocumentosCajaDorada";
      var archivosPorDescargar = this.Contratos.slice();

      var archivosIdJson;
      var archivosIdArray = new Array();

      archivosPorDescargar.forEach(function(value) {
        archivosIdArray.push(value.archivoId);
      });

      archivosIdJson = JSON.stringify(archivosIdArray);

      if (archivosPorDescargar.length > 0) {
        window.location.href =
          rutaDescargarArchivoZip +
          "?archivosIdJson=" +
          archivosIdJson +
          "&nombreZip=" +
          nombreZip;
      } else {
        this.AlertaEmbajadores("No hay contratos para descargar.", true, false);
      }
    },
    descargarTodosLosArchivos() {
      var archivosPorDescargar = this.Contratos.slice();
      if (archivosPorDescargar.length > 0) {
        archivosPorDescargar.forEach(function(value, index) {
          setTimeout(() => {
            window.location.href =
              rutaDescargarArchivoTodos + "?archivoId=" + value.archivoId;
          }, index * 100);
        });
      } else {
        this.AlertaEmbajadores("No hay contratos para descargar.", true, false);
      }
    },
    async ObtenerContratosCliente() {
      this.Contratos = [];
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaCargarContratosCliente, cliente)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            this.avisoCarga = false;
            this.Contratos = resp.data.data;
            if (!this.ContratosFirmados) {
              await this.ValidaContratosFirmados();
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerArchivosGenericos() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaCargarArchivosGenericos, prospecto)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            this.ArchivosGenericos.splice(0);
            this.ArchivosGenericosSoloLectura.splice(0);
            var arregloArchivos = resp.data.data;
            arregloArchivos.forEach((a) => {
              if (
                a.tipoDocumento == 18 ||
                a.tipoDocumento == 20 ||
                a.tipoDocumento == 36 ||
                a.tipoDocumento == 37 ||
                a.tipoDocumento == 38 ||
                a.tipoDocumento == 39 ||
                a.tipoDocumento == 40
              ) {
                if (this.VerificarArchivosGenericosSoloLectura <= 6) {
                  this.ArchivosGenericosSoloLectura.push(a);
                  this.VerificarArchivosGenericosSoloLectura += 1;
                }
              } else {
                if (this.VerificarArchivosGenericos <= 6) {
                  this.ArchivosGenericos.push(a);
                  this.VerificarArchivosGenericos += 1;
                }
              }
            });
            if (this.tipoDocumentoArchivo != null) {
              this.ligaArchivo =
                rutaDescargarArchivo +
                "?archivoId=" +
                0 +
                "&prospectoId=" +
                this.ProspectoId +
                "&tipoDocumento=" +
                this.tipoDocumentoArchivo;
              //this.NombreActual = resp.data.data;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    VerArchivo(archivoId, tipoDocumento) {
      this.archivoIdActual = archivoId;
      switch (tipoDocumento) {
        case 18:
          this.tituloDocumento = "Manual del Consumidor";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 18;
          break;
        case 19:
          this.tituloDocumento = "Guía de Adjudicatario";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 19;
          break;
        case 20:
          this.tituloDocumento = "Tríptico de seguros";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 20;
          break;
        case 21:
          this.tituloDocumento = "Consentimiento Médico";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 21;
          break;
        case 22:
          this.tituloDocumento = "Consentimiento Seguros";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 22;
          break;
        case 26:
          this.tituloDocumento = "Adicional Financiera";
          this.soloLectura = false;
          this.documentoLlenar = 26;
          this.tipoDocumentoArchivo = 26;
          break;
        case 27:
          this.tituloDocumento = "Actividad Profesional";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 27;
          break;
        case 28:
          this.tituloDocumento = "Calendario de eventos";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 28;
          break;
        case 23:
          this.tituloDocumento = "Contrato";
          this.soloLectura = true;
          break;
        case 24:
          this.tituloDocumento = "Hoja de Prueba";
          this.soloLectura = true;
          break;
        case 25:
          this.tituloDocumento = "Kit de Contratacion";
          this.soloLectura = true;
          break;
        case 31:
          this.tituloDocumento = "Solicitud de Inscripción Cotitular";
          this.soloLectura = true;
          break;
        case 32:
          this.tituloDocumento = "Solicitud de Inscripción Representante Legal";
          this.soloLectura = true;
          break;
        case 33:
          this.tituloDocumento = "Solicitud de Inscripción Moral";
          this.soloLectura = true;
          break;
        case 34:
          this.tituloDocumento = "Anexo Solicitud de Inscripción Moral";
          this.soloLectura = true;
          break;
        case 35:
          this.tituloDocumento = "Carta Edad";
          this.soloLectura = true;
          break;
        case 36:
          this.tituloDocumento = "Adjudicators Guide";
          this.soloLectura = true;
          break;
        case 37:
          this.tituloDocumento = "Award Notification";
          this.soloLectura = true;
          break;
        case 38:
          this.tituloDocumento = "Calendar Of Events";
          this.soloLectura = true;
          break;
        case 39:
          this.tituloDocumento = "Consumer Handbook";
          this.soloLectura = true;
          break;
        case 40:
          this.tituloDocumento = "Hircasa Contract";
          this.soloLectura = true;
          break;
      }
      this.ligaArchivo =
        rutaDescargarArchivo +
        "?archivoId=" +
        archivoId +
        "&prospectoId=" +
        this.ProspectoId +
        "&tipoDocumento=" +
        tipoDocumento;
      window.frames[0].contentWindow.location.reload();
    },
    VerContrato(archivoId, tipoDocumento, nombreDocumento) {
      this.soloLectura = true;
      this.ArchivoActual = archivoId;
      switch (tipoDocumento) {
        case 19:
          this.tituloDocumento = "Guía de Adjudicatario";
          break;
        case 23:
          this.tituloDocumento = nombreDocumento;
          break;
        case 24:
          this.tituloDocumento = "Hoja de Prueba";
          break;
        case 25:
          this.tituloDocumento = "Kit de Contratacion";
          break;
        case 29:
          this.tituloDocumento = "Solicitud de Inscripción";
          break;
        case 31:
          this.tituloDocumento = "Solicitud de Inscripción Cotitular";
          break;
        case 32:
          this.tituloDocumento = "Solicitud de Inscripción Representante Legal";
          break;
        case 33:
          this.tituloDocumento = "Solicitud de Inscripción Moral";
          break;
        case 34:
          this.tituloDocumento = "Anexo Solicitud de Inscripción Moral";
          break;
        case 35:
          this.tituloDocumento = "Carta Edad";
          break;
        case 36:
          this.tituloDocumento = "Adjudicators Guide";
          break;
        case 37:
          this.tituloDocumento = "Award Notification";
          break;
        case 38:
          this.tituloDocumento = "Calendar Of Events";
          break;
        case 39:
          this.tituloDocumento = "Consumer Handbook";
          break;
        case 40:
          this.tituloDocumento = "Hircasa Contract";
          break;
      }
      this.ligaArchivo = rutaDescargarContrato + "?archivoId=" + archivoId;
      window.frames[0].contentWindow.location.reload();
      //window.frames['frameNameOrIndex'].location.reload();
      //document.getElementById('iframeid').src = document.getElementById('iframeid').src
    },
    ObtenerTituloArchivo(tipoDocumento) {
      switch (tipoDocumento) {
        case 18:
          return "Manual del Consumidor";
        case 19:
          return "Guía de Adjudicatario";
        case 20:
          return "Tríptico de seguros";
        case 21:
          return "Consentimiento Médico";
        case 22:
          return "Consentimiento Seguros";
        case 23:
          return "Contrato";
        case 24:
          return "Hoja de Prueba";
        case 25:
          return "Kit de Contratacion";
        case 26:
          return "Adicional Financiera";
        case 27:
          return "Actividad Profesional";
        case 28:
          return "Calendario de eventos";
        case 29:
          return "Solicitud de Inscripción";
        case 31:
          return "Solicitud de Inscripción Cotitular";
        case 32:
          return "Solicitud de Inscripción Representante Legal";
        case 33:
          return "Solicitud de Inscripción Moral";
        case 34:
          return "Anexo Solicitud de Inscripción Moral";
        case 35:
          return "Carta Edad";
        case 36:
          return "Adjudicators Guide En";
        case 37:
          return "Award Notification En";
        case 38:
          return "Calendar Of Events En";
        case 39:
          return "Consumer Handbook En";
        case 40:
          return "Hircasa Contract En";
      }
    },
    async rolesMaster() {
      try {
        const resp = await axios.get("/api/Master/Master/ObtenerRolesMaster");
        const obtenerRolMaster = resp.data.data;
        obtenerRolMaster.map((element) => {
          this.roles.push({
            nombre: element.nombreRol,
            rolId: element.rolId,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async proyectoMaster(conEmbajadores) {
      const params = {
        params: { conEmbajadores },
      };
      try {
        const resp = await axios.get(
          "/api/Master/Master/ListarProyectos",
          params
        );
        const obtenerProyecto = resp.data.data;
        obtenerProyecto.map((element) => {
          this.proyectos.push({
            nombre: element.nombre,
            proyectoVentaId: element.proyectoVentaId,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerPosiblesJefes() {
      this.jefes = [];
      this.jefe = null;
      await axios
        .get(rutaConsultarPosiblesJefes + "?rolId=" + this.rol)
        .then(async (resp) => {
          const posiblesJefes = resp.data.data;
          posiblesJefes.map((element) => {
            this.jefes.push({
              jefeId: element.jefeId,
              nombre: element.nombre,
            });
          });
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async gerenciasProyecto(proyectoId) {
      const params = {
        params: { proyectoId },
      };
      try {
        const resp = await axios.get(
          "/api/Master/Prospecto/ListarGerenciasDeUnProyecto",
          params
        );
        const obtenerGerenciasProyecto = resp.data.data;
        obtenerGerenciasProyecto.map((element) => {
          this.gerencias.push({
            gerenciaId: element.gerenciaId,
            nombre: element.nombre,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    CamposLlenosMaster() {
      if (
        this.rol === null ||
        this.rol === "" ||
        this.nombre === null ||
        this.nombre === "" ||
        this.apellidoPaterno === null ||
        this.apellidoPaterno === "" ||
        this.telefono === null ||
        this.telefono === "" ||
        this.telefono.length != 10 ||
        this.correo === null ||
        this.correo === "" ||
        this.proyecto === null
      ) {
        return false;
      } else {
        return true;
      }
    },
    CamposLlenosProspecto() {
      if (
        this.nombre === null ||
        this.nombre === "" ||
        this.apellidoPaterno === null ||
        this.apellidoPaterno === "" ||
        this.telefono === null ||
        this.telefono === "" ||
        this.telefono.length != 10 ||
        this.correo === null ||
        this.correo === "" ||
        this.ProspectoId === null ||
        this.ProspectoId === 0 ||
        this.tipoPersona === null
      ) {
        return false;
      } else {
        return true;
      }
    },
    guardarPerfil() {
      this.loadingGuardar = true;
      if (this.CamposLlenosMaster()) {
        const params = {
          nombres: this.nombre,
          apellidoPaterno: this.apellidoPaterno,
          apellidoMaterno: this.apellidoMaterno,
          telefono: this.telefono,
          correo: this.correo,
          nombreRol: this.nombreRol,
          sucursalId: this.proyectoVentaId,
          gerenciaId: this.gerenciaId,
          activo: true,
          jefeIds: this.jefesSeleccionados.map((jefe) => jefe.jefeId),
        };
        axios.post("/api/Master/Master/CrearMaster", params).then((resp) => {
          if (resp.data.estado === 0) {
            this.loadingGuardar = false;
            this.AlertaEmbajadores("Se ha guardado correctamente", true);
            this.$router.push({
              name: "Administrador",
            });
          } else if (resp.data.estado === 1) {
            this.loadingGuardar = false;
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        });
      } else {
        this.loadingGuardar = false;
        this.AlertaEmbajadores(
          "Por favor llene todos los campos necesarios para crear el perfil.",
          true
        );
      }
    },
    existeJefeSeleccionado() {
      return this.jefesSeleccionados.some((jefe) => jefe.jefeId === this.jefe);
    },
    agregarJefe(jefeId) {
      const jefeSeleccionado = this.jefes.find(
        (jefe) => jefe.jefeId === jefeId
      );
      this.jefesSeleccionados.push(jefeSeleccionado);
      this.jefe = null;
    },
    eliminarJefeSeleccionado(jefeId) {
      const nuevoArreglo = this.jefesSeleccionados.filter(
        (jefe) => jefe.jefeId !== jefeId
      );
      this.jefesSeleccionados = nuevoArreglo;
    },

    //FUNCIONES PARA EDITAR PERFIL
    async obtenerInfoMasterId() {
      let id = this.$route.params.id;
      if (this.$route.name == "EditarPerfil") {
        const params = {
          params: { masterId: id },
        };
        try {
          const resp = await axios.get(
            "/api/Master/Master/ObtenerMasterAdmin",
            params
          );
          const { data } = resp.data;
          console.log(data)
          const {
            nombres,
            apellidoPaterno,
            apellidoMaterno,
            correo,
            telefono,
            rolId,
            sucursalId,
            gerenciaId,
            activo,
            jefesIds,
          } = data;
          (this.nombre = nombres),
            (this.apellidoPaterno = apellidoPaterno),
            (this.apellidoMaterno = apellidoMaterno),
            (this.telefono = telefono),
            (this.correo = correo),
            (this.rol = rolId),
            (this.proyecto = sucursalId),
            (this.gerencia = gerenciaId),
            (this.activo = activo);
          await this.nombrarRol(this.rol);
          await this.obtenerPosiblesJefes();
          const arregloIdsJefes = jefesIds;
          arregloIdsJefes.map((e) => {
            const jefeSeleccionado = this.jefes.find(
              (jefe) => jefe.jefeId === e
            );
            this.jefesSeleccionados.push(jefeSeleccionado);
          });
          this.jefe = null;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async obtenerInfoUsuarioId() {
      let id = this.$route.params.id;
      if (this.$route.name == "EditarPerfil") {
        const params = {
          params: { usuarioId: id },
        };
        try {
          const resp = await axios.get(
            "/api/Master/Master/ObtenerUsuarioAdmin",
            params
          );
          const { data } = resp.data;
          const {
            nombres,
            apellidoPaterno,
            apellidoMaterno,
            correo,
            telefono,
            prospectoId,
            tipoPersona,
            activo,
          } = data;
          (this.nombre = nombres),
            (this.apellidoPaterno = apellidoPaterno),
            (this.apellidoMaterno = apellidoMaterno),
            (this.telefono = telefono),
            (this.correo = correo),
            (this.ProspectoId = prospectoId),
            (this.tipoPersona = tipoPersona),
            (this.activo = activo);
        } catch (error) {
          console.log(error);
        }
      }
    },
    async editarPerfil() {
      this.loadingGuardar = true;
      if (this.tipo == "M") {
        if (this.CamposLlenosMaster()) {
          const params = {
            masterId: this.$route.params.id,
            nombres: this.nombre,
            apellidoPaterno: this.apellidoPaterno,
            apellidoMaterno: this.apellidoMaterno,
            telefono: this.telefono,
            correo: this.correo,
            nombreRol: this.nombreRol,
            sucursalId: this.proyectoVentaId,
            gerenciaId: this.gerenciaId,
            token: this.token,
            activo: true,
            jefesIds: this.jefesSeleccionados.map((jefe) => jefe.jefeId),
          };
          axios
            .post("/api/Master/Master/EditarMasterAdmin", params)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.loadingGuardar = false;
                this.AlertaEmbajadores("Se ha actualizado correctamente", true);
                this.$router.push({
                  name: "Administrador",
                });
              } else if (resp.data.estado === 1) {
                this.loadingGuardar = false;
                this.AlertaEmbajadores(resp.data.mensaje, false);
              }
            });
        } else {
          this.loadingGuardar = false;
          this.AlertaEmbajadores(
            "Por favor llene todos los campos necesarios para crear el perfil.",
            true
          );
        }
      } else {
        if (this.CamposLlenosProspecto()) {
          const params = {
            usuarioId: this.$route.params.id,
            nombres: this.nombre,
            apellidoPaterno: this.apellidoPaterno,
            apellidoMaterno: this.apellidoMaterno,
            telefono: this.telefono,
            correo: this.correo,
            prospectoId: this.ProspectoId,
            tipoPersona: this.tipoPersona,
            activo: this.activo,
          };
          axios
            .post("/api/Master/Master/EditarProspectoAdmin", params)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.loadingGuardar = false;
                this.AlertaEmbajadores("Se ha actualizado correctamente", true);
                this.$router.push({
                  name: "Administrador",
                });
              } else if (resp.data.estado === 1) {
                this.loadingGuardar = false;
                this.AlertaEmbajadores(resp.data.mensaje, false);
              }
            });
        } else {
          this.loadingGuardar = false;
          this.AlertaEmbajadores(
            "Por favor llene todos los campos necesarios para crear el perfil.",
            true
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.titulo-instrucciones {
  color: #000000;
  font-weight: bold;
  text-align: left;
}
</style>
<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.ocultar-texto {
  color: #1e2120;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.titulo-alta-perfil {
  text-align: left;
  font-family: "Poppins";
  font-size: 18px;
  color: #1e2120;
  font-weight: bold;
  width: 100vw;
  flex-grow: 1;
}
.boton-primario {
  border-radius: 0px !important;
  background-color: $color-primario !important;
  box-shadow: none !important;
  color: $blanco !important;
  font-family: $poppins !important;
}
.boton-primario:hover {
  color: $blanco !important;
  background-color: #a56651 !important;
}
.boton-primario:focus {
  box-shadow: none !important;
}
.principal-caja-dorada {
  width: 100vw;
  flex-grow: 1;
}
.titulo-documentos {
  color: $negro-embajadores;
}
.accordion-item {
  border-style: none !important;
}
.accordion-button {
  display: flex;
  border-radius: 0 !important;
  background-color: $color-primario !important;
  color: white !important;
  font-family: $poppins;
  text-align: center !important;
}
.boton--collapsable {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  background-color: $color-primario;
  color: white;
  font-family: $poppins;
  width: 100%;
  padding: 15px;
}
.boton--collapsable::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 15px;
  content: "";
  background-image: url("../../../../../assets/iconos-embajadores/arrowhite.png");
  transition: transform 0.2s ease-in-out;
  background-position-y: 4px;
}
.boton--collapsable:hover {
  color: $blanco;
}
.boton--collapsable:focus {
  outline: none;
  box-shadow: none;
}
.boton--collapsable:not(:not(.collapsed))::after {
  transform: rotate(0deg);
}
.boton--collapsable:not(.collapsed)::after {
  transform: rotate(-180deg);
}
.descarga-todo {
  color: $color-primario;
  text-decoration: underline;
  cursor: pointer;
  line-height: 3.5;
}
.caja-manuales {
  display: grid;
  column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.caja-manuales_dos {
  display: grid;
  column-gap: 25px;
  grid-template-columns: repeat(2, 1fr);
}
.caja-manuales__manual {
  margin-top: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.caja-manuales__manual strong {
  font-size: 14px;
  margin-bottom: 10px;
}
.caja-manules__boton {
  background: $color-primario;
  color: white;
  height: 57px;
  transition: 0.5s;
}
.caja-manules__boton:hover {
  background: #9e624e;
}

.contratos-vacio {
  display: flex;
  justify-content: center;
  background: #ffd9cd;
  flex-direction: column;
}
.contratos-vacio__titulo {
  text-align: center;
  font-weight: bold;
}
.contratos-vacio__icono {
  font-size: 32px;
  margin-bottom: 10px;
  text-align: center;
}

//MODAL ARCHIVO
.principal-caja-dorada .modal-dialog {
  width: 100%;
}
.principal-caja-dorada .modal-archivo {
  border-radius: 0px;
  height: 90vh;
}
.principal-caja-dorada .modal-archivo__encabezado {
  border-style: none;
}
.principal-caja-dorada .pdf-archivo {
  width: 100%;
  height: 100%;
}

.principal-caja-dorada .modal-archivo .modal-archivo__boton {
  background: $color-primario;
  border-radius: 0px;
  border-style: none;
}

/* LOADER */
.contenedor-loader-firmando {
  background-color: #fad4c8;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.contenedor-loader-firmando label {
  animation: blinker 1.5s linear infinite;
  font-weight: 500;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #b8725a;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@media all and (max-width: 767px) {
  .descarga-todo {
    text-align: right;
  }
  .acordeon-embajadores__caja-contratos {
    grid-template-columns: repeat(2, 1fr);
  }
  .caja-manuales {
    grid-template-columns: repeat(2, 1fr);
  }
  .contratos-vacio__titulo {
    font-size: 12px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
